const _ = require('lodash');
const querystring = require('querystring');

// A utility function to safely escape JSON for embedding in a <script> tag
exports.safeStringify = (obj) => {
  return JSON.stringify(obj).replace(/<\/script/g, '<\\/script').replace(/<!--/g, '<\\!--');
};

exports.weightedRandomVariant = (variations = [50, 50]) => {
  // example input [50,50]; weights must add up to 100!
  let sum = 0;
  const randomNumber = Math.random() * 100;

  for (let key = 0; key < variations.length; key++) {
    const value = variations[key];
    sum += value;

    if (randomNumber <= sum) {
      return key + '';
    }
  }
};

exports.getExperimentData = (req, res, experimentId, variations, isExperimentActive = false, cookieSettings = { maxAge: 3628800000 }) => {
  const variantCookie = _.get(req, `cookies[${experimentId}]`);
  const experimentVariant = variantCookie || this.weightedRandomVariant(variations);
  const queryVariant = _.get(req, 'query.t', '0');
  const variant = isExperimentActive ? experimentVariant : queryVariant;

  if (_.get(req, 'query.t')) {
    return {
      id: experimentId,
      isExperimentActive,
      isVariantActive: '1' === queryVariant,
      variant
    };
  }

  if (!variantCookie && isExperimentActive) {
    res.cookie(experimentId, variant, cookieSettings);
  }

  return {
    id: experimentId,
    isExperimentActive,
    isVariantActive: '1' === variant,
    variant
  };
};

exports.getBaseUrl = (url = '') => {
  return url.split('?')[0];
};

exports.redirectHelper = (req = {}, res = {}, status, permalink, query = {}) => {
  if (_.isEmpty(req.query) && _.isEmpty(query)) {
    return res.redirect(status, permalink);
  }
  return res.redirect(status, permalink + `?${querystring.stringify(_.merge({}, req.query, query))}`);
};

exports.toTitleCase = (str) => {
  if (!str) {
    return;
  }
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}